var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 38,
    fill: "#9A2167"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    cx: 150,
    cy: 150,
    clipRule: "evenodd",
    d: "M127.062 241.181C86.2341 230.943 56 194.002 56 150C56 98.0854 98.0852 56 150 56C201.915 56 244 98.0854 244 150C244 194.002 213.766 230.943 172.938 241.181L166.115 203.646C189.188 196.725 206 175.326 206 150C206 119.072 180.928 94 150 94C119.072 94 94 119.072 94 150C94 175.326 110.812 196.725 133.885 203.646L127.062 241.181Z",
    fill: "#1E1F1E"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 150 150",
    to: "-360 150 150",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    cx: 150,
    cy: 150,
    clipRule: "evenodd",
    d: "M117.03 296.365C50.0478 281.342 0 221.516 0 150C0 67.1572 67.1573 0 150 0C232.843 0 300 67.1572 300 150C300 221.516 249.952 281.342 182.97 296.365L176.344 259.913C226.046 248.044 263 203.338 263 150C263 87.5918 212.408 37 150 37C87.5918 37 37 87.5918 37 150C37 203.338 73.9543 248.044 123.656 259.913L117.03 296.365Z",
    fill: "#18BDDE"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 150 150",
    to: "360 150 150",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.f84a31c5f331f131f0ee08310610469b.svg";
export { ForwardRef as ReactComponent };